const siteUrl = import.meta.env.VITE_SITE_URL || "https://hoobuy.biz";
const faviconUrl =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Hoobuy Spreadsheet",
  url: siteUrl,
  description:
    "Hub oficial do hoobuyspreadsheet atualizado 2026 com lista completa de produtos virais, guias e recursos.",
  inLanguage: "pt-BR",
  publisher: {
    "@type": "Organization",
    name: "hoobuy.biz",
    logo: {
      "@type": "ImageObject",
      url: faviconUrl,
    },
  },
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function HomePageJsonLd() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
    />
  );
}